function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.37999 4.40039H3.51999C3.40999 4.40039 3.29999 4.51039 3.29999 4.62039V10.7804C3.29999 10.8904 3.40999 11.0004 3.51999 11.0004H6.37999C6.48999 11.0004 6.59999 10.8904 6.59999 10.7804V4.62039C6.59999 4.51039 6.48999 4.40039 6.37999 4.40039Z",
  fill: "#2371F1"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.51999 3.3H10.78C10.89 3.3 11 3.19 11 3.08V0.55C11 0.22 10.78 0 10.45 0H3.51999C3.40999 0 3.29999 0.11 3.29999 0.22V3.08C3.29999 3.19 3.40999 3.3 3.51999 3.3Z",
  fill: "#2371F1"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.70001 4.62039V10.7804C7.70001 10.8904 7.81001 11.0004 7.92001 11.0004H10.45C10.78 11.0004 11 10.7804 11 10.4504V4.62039C11 4.51039 10.89 4.40039 10.78 4.40039H7.92001C7.81001 4.40039 7.70001 4.51039 7.70001 4.62039Z",
  fill: "#2371F1"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M1.98 0H0.55C0.22 0 0 0.22 0 0.55V10.45C0 10.78 0.22 11 0.55 11H1.98C2.09 11 2.2 10.89 2.2 10.78V0.22C2.2 0.11 2.09 0 1.98 0Z",
  fill: "#2371F1"
});

var SvgTemplate = function SvgTemplate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTemplate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/template.82c13cee.svg";
export { ForwardRef as ReactComponent };